import { Collapse, Switch, Tooltip } from 'antd';
import ImageUploader from '../imageUploader/galleryImage'
// import { useDispatch, useSelector } from 'react-redux';
// import {  checkHighlightImage } from '../../Redux/Actions/CardAction';
const { Panel } = Collapse;

const Gallery = ({edit}) => {
  // const dispatch = useDispatch();
  // const { checkHighlight,  } = useSelector((state) => state.cardReducer);
  const onChange = (key) => {
    console.log(key);
  };
  const onChangeToggle = (checked) => {
    console.log(`switch to ${checked}`);
    dispatch(checkHighlightImage(checked));
  };

  // const genExtra = () => (
  //   <Switch defaultChecked={checkHighlight} className='bg-gray-400' onChange={onChangeToggle} />
  // ); 

  return (
    <Collapse defaultActiveKey={['0']} className='flex justify-between' onChange={onChange}>
      <Panel header="Gallery" key="1" className='w-full' >
        <ImageUploader/>
      </Panel>
      {/* {edit ?  */}
      <p className='w-20 bg-white  border-b rounded-r-xl '>
        <p className='bg-slate-50 h-[47px] border-b rounded-r-md  py-3'>
        {/* <Tooltip placement="top" title={`${checkHighlight ? 'hide gallery' : 'show gallery'}`}>
        <Switch defaultChecked={checkHighlight} className='bg-gray-400' onChange={onChangeToggle} />
        </Tooltip> */}
        </p>
      </p> 
      {/* : ''
      } */}
    </Collapse>
  );
};
export default Gallery;